import { RatioProgressBar, RatioProgressBarProps } from '@cast/design-system';

type Props = {
  egress: number;
  ingress: number;
  size?: RatioProgressBarProps['size'];
};

export const TrafficRatioBars = ({ egress, ingress, size }: Props) => {
  return (
    <RatioProgressBar
      hideBorders
      bars={[
        {
          value: egress,
          color: 'indigo.200',
        },
        {
          value: ingress,
          color: 'grey.700',
        },
      ]}
      size={size}
    />
  );
};
